import React from "react";
import NavBar from "../components/NavBar";
import PartnersPage from "../components/PartnersPage";
import Footer from "../components/Footer";

const BecomeOurPartner = () => {
    return(
        <div>
            <NavBar/>
            <PartnersPage/>
            <Footer/>
        </div>
    )
}

export default BecomeOurPartner;